export default __webpack_public_path__ + "static/media/stop.34ae83f4.svg";